import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react';

const Footer = ({ onOpenContactForm }) => {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="main-footer" className="relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #1a0a2e 0%, #0f0518 100%)'
    }}>
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-[#7C3AED]/10 blur-[120px]" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] rounded-full bg-[#14B8A6]/5 blur-[80px]" />

      <div className="mx-auto w-full max-w-7xl px-4 md:px-8 py-20 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <span className="text-2xl font-black tracking-tight text-white mb-4 block" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Brand<span className="text-[#14B8A6]">TM</span>
            </span>
            <p className="text-sm text-white/40 leading-relaxed">
              Expert US trademark registration and federal brand protection services. Licensed trademark attorneys nationwide.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-[#14B8A6] mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['why-register', 'process', 'pricing', 'testimonials', 'faq'].map(id => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollTo(id)}
                    className="text-sm text-white/40 hover:text-white transition-colors capitalize flex items-center gap-1 group"
                  >
                    {id}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-[#14B8A6] mb-6">Our Process</h4>
            <ul className="space-y-3">
              {['Trademark Search', 'USPTO Filing', 'Office Action Response', 'Trademark Monitoring', 'Registration Certificate'].map(item => (
                <li key={item}>
                  <button onClick={() => scrollTo('process')} className="text-sm text-white/40 hover:text-white transition-colors text-left">
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-[#14B8A6] mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-[#7C3AED]/20 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-4 h-4 text-[#14B8A6]" />
                </div>
                <a href="tel:+18001234567" className="text-sm text-white/50 hover:text-white transition-colors mt-1">
                  +1 (800) 123-4567
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-[#7C3AED]/20 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-4 h-4 text-[#14B8A6]" />
                </div>
                <a href="mailto:info@brandtrademarkregistration.com" className="text-sm text-white/50 hover:text-white transition-colors mt-1 break-all">
                  info@brandtrademarkregistration.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-[#7C3AED]/20 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-4 h-4 text-[#14B8A6]" />
                </div>
                <span className="text-sm text-white/50 mt-1">7051 Hollywood Blvd, Los Angeles, CA 90028</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30">
            &copy; {currentYear} Brand Trademark Registration. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs">
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-white/30 hover:text-[#14B8A6] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" data-testid="footer-terms-link" className="text-white/30 hover:text-[#14B8A6] transition-colors">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
